<template>
    <PerfectScrollbar class="AllPwaMobile">
      <header-menu></header-menu>

      <div v-if="isTranslationsReady" class="AllSiteHeaderMenu">
        <div class="MenuAllSiteHeaderMenuDeposit">
          <div class="ChildSelectTab">
            <!-- <div class="TabChildSelectTab">
              <vs-radio color="#BB86FC" v-model="radios1" vs-name="radios1" vs-value="rial">
                {{ $t('deposit.rial') }}
              </vs-radio>
            </div> -->
            
            <div class="TabChildSelectTab">
              <vs-radio color="#BB86FC" v-model="radios1" vs-name="radios1" vs-value="dollar">
                {{ $t('deposit.dollar') }}
              </vs-radio>
            </div>
          </div>

          <p>
            {{ $t('deposit.title') }}
          </p>
        </div>
      </div>

      <div class="GetDollarSelect">
        <div v-if="radios1 == 'dollar'" class="ShowSelectSearch">
          <label>{{ $t('deposit.selectNetwork') }}</label>

          <multiselect 
            :placeholder="$t('deposit.selectPlaceholder')" 
            v-model="value" 
            :options="options" 
            label="name" 
            track-by="name"
          ></multiselect>

          <div v-if="selectedWalletAddress" class="wallet-address-container">
            <div class="wallet-network">
              <span>{{ value ? (value.network || value.all.network) : '' }}</span>
            </div>
            <div class="wallet-address">
              <span>{{ selectedWalletAddress }}</span>
              <VsxIcon 
                @click="copyWalletAddress" 
                style="cursor: pointer" 
                iconName="Copy" 
                :size="20" 
                :color="color" 
                type="linear" 
              />
            </div>
          </div>
        </div>

        
        <div v-if="radios1 == 'dollar'">
          <div>
            <div v-if="FalseShow" class="divQRCodeVue3">
              <QRCodeVue3
                :key="qrKey"
                :width="150"
                :height="150"
                :value="selectedWalletAddress"
                :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                :imageOptions="{
                  hideBackgroundDots: true,
                  imageSize: 0.4,
                  margin: 0,
                  src: require('@/assets/img/darkLP.png'),
                }"
                :dotsOptions="{
                  type: 'extra-rounded',
                  color: this.color,
                  gradient: {
                    type: 'linear',
                    rotation: 0,
                    colorStops: [
                      { offset: 0, color: '#BB86FC' },
                      { offset: 1, color: '#BB86FC' },
                    ],
                  },
                }"
                :backgroundOptions="{ color: '#121212' }"
                :cornersSquareOptions="{ type: 'dot', color: '#4c277a' }"
                :cornersDotOptions="{ type: undefined, color: '#4c277a' }"
                fileExt="png"
                myclass="my-qur"
                imgclass="img-qr"
                downloadButton="my-button"
                :downloadOptions="{ name: 'vqr', extension: 'png' }"
              />
            </div>

            <div v-if="FalseShow1" class="divQRCodeVue3">
              <QRCodeVue3
                :key="qrKey"
                :width="150"
                :height="150"
                :value="selectedWalletAddress"
                :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                :imageOptions="{
                  hideBackgroundDots: true,
                  imageSize: 0.4,
                  margin: 0,
                  src: require('@/assets/img/darkLP.png'),
                }"
                :dotsOptions="{
                  type: 'extra-rounded',
                  color: this.color,
                  gradient: {
                    type: 'linear',
                    rotation: 0,
                    colorStops: [
                      { offset: 0, color: '#BB86FC' },
                      { offset: 1, color: '#BB86FC' },
                    ],
                  },
                }"
                :backgroundOptions="{ color: '#f5f5f5' }"
                :cornersSquareOptions="{ type: 'dot', color: '#4c277a' }"
                :cornersDotOptions="{ type: undefined, color: '#4c277a' }"
                fileExt="png"
                myclass="my-qur"
                imgclass="img-qr"
                downloadButton="my-button"
                :downloadOptions="{ name: 'vqr', extension: 'png' }"
              />
            </div>
          </div>
        </div>

        <div v-if="radios1 == 'rial'" class="ShowSelectSearch">
          <label>{{ $t('deposit.selectBank') }}</label>
          <multiselect :placeholder="$t('deposit.selectPlaceholder')" v-model="value1" :options="option1" label="name" track-by="name"></multiselect>
        </div>

        <div style="margin-top: 20px !important;" class="ShowSelectSearch">
          <label v-if="radios1 == 'dollar'">{{ $t('deposit.amountDollar') }}</label>
          <label v-if="radios1 == 'rial'">{{ $t('deposit.amountRial') }}</label>
          <input class="InputX" type="text" :placeholder="$t('deposit.amount')" v-model="moneyDollar">
        </div>

   


        <div v-if="radios1 == 'dollar'" style="margin-top: 30px !important;" class="ShowSelectSearch">
          <span>{{ $t('deposit.uploadImageText') }}</span>
          <span style="font-size: .9rem;">{{ $t('deposit.txidLabel') }}</span>
          <span>{{ $t('deposit.transactionId') }}</span>
          <input class="InputX" type="text" :placeholder="$t('deposit.txidPlaceholder')" v-model="TXID">

          <div class="file-upload-container">
            <input 
              type="file" 
              ref="fileInput" 
              @change="handleFileUpload" 
              accept="image/*"
              class="file-input"
              style="display: none"
            >
            <div @click="$refs.fileInput.click()" class="upload-button">
              <div style="top: 39.5px" class="IconDivShowSelectSearch">
                <VsxIcon iconName="Image" :size="25" :color="color" type="linear" />
              </div>
              <span v-if="selectedFile" class="selected-file">{{ selectedFile.name }}</span>
            </div>
          </div>
        </div>

        <div v-if="radios1 == 'rial'" style="margin-top: 30px !important;" class="ShowSelectSearch">
          <span>{{ $t('deposit.rialTransactionInfo') }}</span>
          <input class="InputX" type="text" :placeholder="$t('deposit.paymentIdPlaceholder')" v-model="shenase">

          <div class="file-upload-container">
            <input 
              type="file" 
              ref="fileInput" 
              @change="handleFileUpload" 
              accept="image/*"
              class="file-input"
              style="display: none"
            >
            <div @click="$refs.fileInput.click()" class="upload-button">
              <div style="top: 39.5px" class="IconDivShowSelectSearch">
                <VsxIcon iconName="Image" :size="25" :color="color" type="linear" />
              </div>
              <span v-if="selectedFile" class="selected-file">{{ selectedFile.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div @click="!isLoading && BtnSendData()" :class="{'ButtonShowSelectSearch': true, 'disabled': isLoading}">
        <span v-if="!isLoading">{{ $t('common.confirm') }}</span>
        <vs-spinner v-else color="white" />
      </div>
  
      <menu-bar></menu-bar>
    </PerfectScrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import Multiselect from 'vue-multiselect';
import axios from "@/axios";
import {toast} from "vue3-toastify";
import QRCodeVue3 from "qrcode-vue3";

export default {
  name: 'depositUser',
  components: {
    PerfectScrollbar,
    Multiselect,
    QRCodeVue3
  },
  data() {
    return {
      getWay: [],
      radios1: 'dollar',
      shenase: '',
      TXID: '',
      FalseShow: true,
      FalseShow1: false,
      moneyDollar: '',
      description: '',
      value: null,
      UserGet: [],
      qrValue: 'dadepardazan',
      qrKey: 0,
      options: [],
      DollarBank: [],
      RialBank: [],
      isLoading: false,
      value1: {},
      option1: [],
      cardNumber: '',
      bankName: '',
      bankImage: '',
      iban: '',
      cardHolderName: '',
      errorMessage: '',
      color: '#BB86FC',
      selectedFile: null,
      isTranslationsReady: false,
      selectedWalletAddress: '',
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (!newValue) {
          this.selectedWalletAddress = '';
          return;
        }

        if (newValue.address) {
          this.selectedWalletAddress = newValue.address;
        } else if (newValue.all && newValue.all.address) {
          this.selectedWalletAddress = newValue.all.address;
        }

        if (this.selectedWalletAddress) {
          const networkName = newValue.network || (newValue.all && newValue.all.network);
          
          // Update QR code visibility based on theme
          this.FalseShow = this.theme !== 'light';
          this.FalseShow1 = this.theme === 'light';
          this.color = this.theme === 'light' ? '#2E1977' : '#BB86FC';
          
          // Force QR code reload
          this.qrKey++;

          toast(`${networkName} ${this.$t('deposit.networkSelected')}`, {
            autoClose: 3000,
            position: "top-right",
            type: "success"
          });
        }
      },
      immediate: true
    },
    value1: {
      handler(newValue) {
        if (!newValue) {
          this.bankName = ''
          return
        }
        const all = newValue.all || {}
        const meta = all.metadata || {}
        this.bankName = meta.bank_title || all.network || all.label || ''
      },
      immediate: true
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.currentLang;
    },
    theme() {
      return this.$store.state.theme;
    }
  },
  methods: {
    DepositClick(){
      if (this.radios1 == 'rial') {
        toast(this.$t('deposit.successMessage'), {
          autoClose: 3000,
          position: "top-right",
          type: "success",
        });
      }

      if (this.radios1 == 'dollar') {
        toast(this.$t('deposit.successMessage'), {
          autoClose: 3000,
          position: "top-right",
          type: "success",
        });
      }
    },
    formatNumber(num) {
      if (typeof num !== 'string') {
        num = String(num);
      }
      return num.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
    },
    clickPointer(){
      navigator.clipboard.writeText(this.qrValue);
    },
    nameWithLang ({name, language}) {
      return `${name} — [${language}]`
    },
    identifyBank() {
      const bin = this.cardNumber.substring(0, 6);
      const bankInfo = this.getBankInfo(bin);
      this.bankName = bankInfo.name;
      this.bankImage = bankInfo.image;
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if( savedTheme == "light"){
        this.color = '#2E1977'
        this.FalseShow1 = true
        this.FalseShow = false
      }else{
        this.color = '#BB86FC'
        this.FalseShow = true
        this.FalseShow1 = false
      }
    },
    async getWallet(){
      const userData = localStorage.getItem('user');
      if (!userData) {
        toast(this.$t('deposit.errors.loginRequired'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
        return;
      }

      const userData1 = JSON.parse(userData);
      this.UserGet = userData1;

      this.DollarBank = [];
      this.RialBank = [];
      this.getWay = []

      try {
        const response = await axios.post('/get-deposit', { user_id: userData1.id });

        if (!response.data || !Array.isArray(response.data) || response.data.length < 2) {
          throw new Error('Invalid response format from server');
        }

        // data layout: [ userWallets, adminDepositAccounts, currencies ]
        const adminDepositAccounts = Array.isArray(response.data[1]) ? response.data[1] : [];
        this.getWay = response.data[2] || [];

        // Build fiat (rial) accounts list from admin-defined deposit accounts
        this.option1 = [];
        for (const acc of adminDepositAccounts) {
          const currencyType = (acc && acc.currency && acc.currency.type) ? String(acc.currency.type).toLowerCase() : '';
          if (currencyType === 'fiat') {
            const meta = acc.metadata || {};
            const bankTitle = meta.bank_title || acc.network || acc.label || (acc.currency && acc.currency.code) || '';
            const cardNumber = meta.card_number || '';
            const shabaNumber = meta.shaba_number || '';
            const display = cardNumber ? `${bankTitle} - ${cardNumber}` : bankTitle;
            this.option1.push({
              name: display,
              value: acc.id,
              all: {
                id: acc.id,
                bank: { title: bankTitle },
                card_number: cardNumber,
                shaba_number: shabaNumber,
                address: acc.address,
                network: acc.network,
                label: acc.label,
                currency: acc.currency,
                metadata: meta,
              }
            });
          }
        }

        // Build crypto (dollar) accounts list from admin-defined deposit accounts
        this.options = [];
        for (const acc of adminDepositAccounts) {
          const currencyType = (acc && acc.currency && acc.currency.type) ? String(acc.currency.type).toLowerCase() : '';
          if (currencyType === 'crypto') {
            const option = {
              name: `${acc.currency?.code || ''} - ${acc.network} - ${acc.label}`.trim(),
              value: acc.id,
              network: acc.network,
              address: acc.address,
              all: acc
            };
            this.options.push(option);
          }
        }

      } catch (error) {
        let errorMessage = this.$t('deposit.errors.invalidResponse');
        if (error.message === 'Network error - please check your connection') {
          errorMessage = this.$t('deposit.errors.networkError');
        } else if (error.message === 'Invalid response format from server') {
          errorMessage = this.$t('deposit.errors.invalidFormat');
        }

        toast(errorMessage, {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      }
    },
    async BtnSendData(){
      if (this.isLoading) return;
      this.isLoading = true;

      const userData = localStorage.getItem('user');
      if (!userData) {
        toast(this.$t('deposit.errors.loginRequired'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
        this.isLoading = false;
        return;
      }

      const userData1 = JSON.parse(userData);

      if (this.radios1 === 'dollar') {
        if (!this.value || !this.value.value) {
          toast(this.$t('deposit.errors.networkRequired'), {
            autoClose: 3000,
            position: "top-right",
            type: "warning",
          });
          this.isLoading = false;
          return;
        }
      } else if (this.radios1 === 'rial') {
        if (!this.value1 || !this.value1.value) {
          toast(this.$t('deposit.errors.networkRequired'), {
            autoClose: 3000,
            position: "top-right",
            type: "warning",
          });
          this.isLoading = false;
          return;
        }
      }

      if (!this.moneyDollar) {
        toast(this.$t('deposit.errors.amountRequired'), {
          autoClose: 3000,
          position: "top-right",
          type: "warning",
        });
        this.isLoading = false;
        return;
      }

      if (this.radios1 === 'dollar' && !this.TXID) {
        toast(this.$t('deposit.errors.txidRequired'), {
          autoClose: 3000,
          position: "top-right",
          type: "warning",
        });
        this.isLoading = false;
        return;
      }

      try {
        const formData = new FormData();

        // Resolve selected admin deposit account
        const selected = this.radios1 === 'dollar' ? this.value : this.value1;
        const selectedAcc = selected?.all || {};
        const selectedCurrencyCode = (selectedAcc.currency && selectedAcc.currency.code) ? String(selectedAcc.currency.code).toUpperCase() : (this.radios1 === 'dollar' ? 'USD' : 'IRR');
        const selectedCurrencyType = (selectedAcc.currency && selectedAcc.currency.type) ? String(selectedAcc.currency.type).toLowerCase() : (this.radios1 === 'dollar' ? 'crypto' : 'fiat');
        const methodCode = selectedCurrencyType === 'crypto' ? 1 : 2;

        formData.append('method_code', String(methodCode));
        formData.append('user_id', userData1.id);
        formData.append('currency', selectedCurrencyCode);
        formData.append('gateway', selectedAcc.label || selectedAcc.network || 'Gateway');
        formData.append('amount', this.moneyDollar);
        formData.append('deposit_account_id', selected.value);

        formData.append('لینک_تایید_تراکنش', this.TXID);

        if(this.radios1 === 'dollar'){
          if (this.selectedFile) {
            formData.append('ارسال_رسید_تایید_تراکنش_(_اختیاری)', this.selectedFile);
          }
        }else{
          if (this.selectedFile) {
            formData.append('ارسال_رسید_پرداخت', this.selectedFile);
          }
        }

        const response = await axios.post('/user-data-update', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data && response.data.success) {
          this.selectedFile = null;
          this.description = '';
          if (this.$refs.fileInput) {
            this.$refs.fileInput.value = '';
          }
          
          toast(this.$t('deposit.successMessage'), {
            autoClose: 3000,
            position: "top-right",
            type: "success",
          });

          this.$router.push('/transaction');
          return;
        }
      } catch (error) {
        toast(this.$t('deposit.errors.submitError'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
      }
    },
    changeLanguage(lang) {
      this.$store.dispatch('changeLanguage', lang);
      this.$i18n.locale = lang;
    },
    copyWalletAddress() {
      if (this.selectedWalletAddress) {
        navigator.clipboard.writeText(this.selectedWalletAddress);
        toast(this.$t('deposit.addressCopied'), {
          autoClose: 3000,
          position: "top-right",
          type: "success",
        });
      }
    },
    copyCardNumber(){
      const card = this.value1?.all?.card_number
      if (!card) return
      navigator.clipboard.writeText(card)
      toast(this.$t('deposit.addressCopied'), {
        autoClose: 3000,
        position: "top-right",
        type: "success",
      });
    },
    copyShabaNumber(){
      const shaba = this.value1?.all?.shaba_number
      if (!shaba) return
      navigator.clipboard.writeText(shaba)
      toast(this.$t('deposit.addressCopied'), {
        autoClose: 3000,
        position: "top-right",
        type: "success",
      });
    }
  },
  created() {
    this.isTranslationsReady = true;
    this.$i18n.locale = this.currentLang;
  },
  mounted() {
    this.color = this.theme === 'light' ? '#2E1977' : '#BB86FC';
    this.FalseShow = this.theme !== 'light';
    this.FalseShow1 = this.theme === 'light';
    this.getWallet();
  }
}
</script>

<style scoped>
.file-upload-container {
  margin-top: 10px;
  width: 100%;
}

.upload-button {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  border: 1px dashed var(--vs-primary);
  transition: all 0.3s ease;
}

.upload-button:hover {
  background: rgba(187, 134, 252, 0.1);
}

.upload-text {
  color: var(--vs-primary);
  font-size: 0.9rem;
}

.selected-file {
  color: var(--vs-primary);
  font-size: 0.9rem;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ButtonShowSelectSearch.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.wallet-address-container {
  margin-top: 15px;
  background: rgba(187, 134, 252, 0.1);
  border-radius: 8px;
  padding: 12px;
}

.wallet-network {
  margin-bottom: 8px;
}

.wallet-network span {
  color: #BB86FC;
  font-size: 0.9rem;
  font-weight: 500;
}

.wallet-address {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.2);
  padding: 8px 12px;
  border-radius: 6px;
  gap: 10px;
}

.wallet-address span {
  flex: 1;
  font-family: monospace;
  font-size: 0.9rem;
  word-break: break-all;
}

.select-network-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  background: rgba(187, 134, 252, 0.1);
  border-radius: 8px;
  margin: 20px 0;
}

.select-network-message p {
  color: #BB86FC;
  font-size: 0.9rem;
}
</style>
  
  